import React, { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import { withTranslation } from "react-i18next"

const DeclineRepairOfferModal = ({ isOpen, toggle, onDecline, t }) => {
  const [reason, setReason] = useState("")

  const handleSubmit = () => {
    onDecline(reason)
    setReason("")
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t("Decline Repair Offer")}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="reason">{t("Reason for declining")}</Label>
            <Input
              type="textarea"
              name="reason"
              id="reason"
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder={t(
                "Please enter your reason for declining the offer"
              )}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {t("Cancel")}
        </Button>
        <Button color="danger" onClick={handleSubmit} disabled={!reason.trim()}>
          {t("Decline Offer")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default withTranslation()(DeclineRepairOfferModal)
